import { TechnologyEnum } from '@modules/filters/enums';

export const technologyLabel = {
  [TechnologyEnum.WiFi]: 'WiFi',
  [TechnologyEnum.Sensors]: 'Sensors',
};
